<template>
    <div id="app">
        <router-view v-if="$route.meta.layout === 'login' || $route.meta.layout === 'agreement' || $route.meta.layout === 'privacy'" />
        <Layout v-else />
    </div>
</template>

<script>
import Layout from './components/Layout.vue';

export default {
    name: 'App',
    components: {
        Layout,
    },
    mounted() {
        console.log(this.$route, 'index');
    },
};
</script>

<style>
@import './assets/reset.css';
.dialogTopTitle {
    font-size: 24px;
    color: #7a2a20;
    font-weight: bold;
}
</style>
